import {Component} from '@angular/core';
import {BasePatientPage} from "../../base-patient-page";
import {FormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {provideNativeDateAdapter} from "@angular/material/core";
import {Interval} from "luxon";
import {MatButtonModule} from "@angular/material/button";
import {SurveyQuestions} from "@allaihealth/survey";

/** The demographic information for a patient */
@Component({
	selector: 'app-info',
	imports: [
		FormsModule,
		MatFormFieldModule,
		MatSelectModule,
		MatInputModule,
		MatDatepickerModule,
		MatButtonModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './info.component.html',
	styleUrl: './info.component.scss'
})
export class InfoComponent extends BasePatientPage {

	override ngOnInit() {
		super.ngOnInit();
	}

	get age() {
		const diff = Interval.fromDateTimes(this.patient.birthdate, new Date());
		return Math.floor(diff.length("years"));
	}

	protected checkResponsibleParty(value:any) {
		if(value == "SELF") {
			//this.data.responsible_party_name = "";
			//this.data.responsible_party_relationship = "";
		}
	}

	protected readonly SurveyQuestions = SurveyQuestions;
}

